__turbopack_context__.v({
  "eyepiece-name": "eyepiece-module__LvKrVW__eyepiece-name",
  "eyepiece-note": "eyepiece-module__LvKrVW__eyepiece-note",
  "eyepiece-rule": "eyepiece-module__LvKrVW__eyepiece-rule",
  "eyepiece-tick": "eyepiece-module__LvKrVW__eyepiece-tick",
  "name": "eyepiece-module__LvKrVW__name",
  "note": "eyepiece-module__LvKrVW__note",
  "rule": "eyepiece-module__LvKrVW__rule",
  "segment": "eyepiece-module__LvKrVW__segment",
  "segmentFound": "eyepiece-module__LvKrVW__segmentFound",
  "tick": "eyepiece-module__LvKrVW__tick",
});
